module.exports = __webpack_public_path__ + "img/logo-company.e0f73b83.png";